import React, { useState } from 'react';

import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemPanel,
	AccordionItemButton
} from 'react-accessible-accordion';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { SITE_INSTAGRAM_USER } from '../config/site';

import arrow_up from '../img/arrow_up.svg';
import arrow_down from '../img/arrow_down.svg';

const MobileAndDecktopAcordion = props => {
	const { t } = useTranslation( 'faq' );
	const {language, origin} = useSelector(store => store)
	const isSubBy =  origin === 'sub';

	const [selecterAcc, setSelecterAcc] = useState( [] );
	return (
		<div className="accordion_container">
			{ props.width <= 1224 ? (
				<div className="accordion_close">
					<p onClick={ () => props.hideModal( false ) }>X</p>
				</div>
			) : null }

			<Accordion allowZeroExpanded={ true } onChange={ e => setSelecterAcc( e[0] ) }>
				<AccordionItem uuid="1">
					<AccordionItemHeading>
						<AccordionItemButton>
							<h3>{ t( 'incorrect_points.title' ) }</h3>
							<img src={ selecterAcc === '1' ? arrow_up : arrow_down } alt=""/>
						</AccordionItemButton>
					</AccordionItemHeading>
					<AccordionItemPanel>
						<p>{ t( 'incorrect_points.paragraph' ) }</p>
						<p>
							1. { t( 'incorrect_points.reason1' ) }
						</p>
						<p>
							2. { t( 'incorrect_points.reason2' ) }
						</p>
						<p>
							3. { t( 'incorrect_points.reason3' ) }
						</p>
						<p>
							4. { t( 'incorrect_points.reason4' ) }
						</p>
						<p>5. { t( 'incorrect_points.reason5' ) }</p>
					</AccordionItemPanel>
				</AccordionItem>

				<AccordionItem uuid="2">
					<AccordionItemHeading>
						<AccordionItemButton>
							<h3>{ t( 'cannot_find_myself.title' ) }</h3>
							<img src={ selecterAcc === '2' ? arrow_up : arrow_down } alt=""/>
						</AccordionItemButton>
					</AccordionItemHeading>
					<AccordionItemPanel>
						<p>
							{ t( 'cannot_find_myself.paragraph1' ) }
						</p>
						<p>{ t( 'cannot_find_myself.paragraph2' ) }</p>
					</AccordionItemPanel>
				</AccordionItem>

				<AccordionItem uuid="3">
					<AccordionItemHeading>
						<AccordionItemButton>
							<h3>{ t( 'update_rating.title' ) }</h3>
							<img src={ selecterAcc === '3' ? arrow_up : arrow_down } alt=""/>
						</AccordionItemButton>
					</AccordionItemHeading>
					<AccordionItemPanel>
						<p>{ t( 'update_rating.paragraph' ) }</p>
					</AccordionItemPanel>
				</AccordionItem>

				<AccordionItem uuid="4">
					<AccordionItemHeading>
						<AccordionItemButton>
							<h3>{ t( 'no_points_added.title' ) }</h3>
							<img src={ selecterAcc === '4' ? arrow_up : arrow_down } alt=""/>
						</AccordionItemButton>
					</AccordionItemHeading>
					<AccordionItemPanel>
						<p>
							{ t( 'no_points_added.paragraph' ) }
						</p>
					</AccordionItemPanel>
				</AccordionItem>
				{ props.width < 1224 ? (
					props.bloggerData.isSupportEnabled === 1
					&& props.bloggerData.showLink === 1 ? (
						<AccordionItem uuid="5">
							<AccordionItemHeading>
								<AccordionItemButton>
									<h3>{t("contact_support.title")}</h3>
									<img src={ selecterAcc === '5' ? arrow_up : arrow_down } alt=""/>
								</AccordionItemButton>
							</AccordionItemHeading>
							<AccordionItemPanel>
								<div>
									<p>
										{t("contact_support.part1")}{ ' ' }
										{language === "ru" ? <a
												href={ `https://www.instagram.com/${SITE_INSTAGRAM_USER}/` }
											target="_blank"
											rel="noopener noreferrer"
										>
											<span className="support-badge">@{ SITE_INSTAGRAM_USER }</span>
										</a> : <a onClick={() => window.MeTalk('openSupport')}><span className="support-badge">chat</span></a> }
										{ ' ' }
										{t("contact_support.part2")} :)
									</p>
								</div>
							</AccordionItemPanel>
						</AccordionItem>
					) : null
				) : null }
			</Accordion>
			{ props.width < 1224 && props.bloggerData.showLink === 1 ? (
				<a style={ { textDecoration: 'none' } } href={ `${window.location.origin}/${ props.bloggerData.link }` }
				   target="_blank" rel="noopener noreferrer">
					<div className="sidebar_button sidebar_add_service">
						<span>{ t("Подключить сервис") }</span>
					</div>
				</a>
			) : null }
		</div>
	);
};

export default MobileAndDecktopAcordion;
